import React, { Component } from 'react';
import { SearchResult } from './SearchResult.component';

import $ from 'jquery';
import { PersonCasesResult } from './PersonCases.component';
import { SearchSelect } from './SearchSelect.component';
import Textfield from '@atlaskit/textfield';
import interpolate from '../utils/interpolate';

class FreeTextField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedData: '',
      userData: '',
      fieldConfig: props.fieldConfig,
      fields: props.fieldConfig?.issueFields,
      jql: props.fieldConfig?.jql,
      issueFieldsArray: props.issueFieldsArray,
      // defaultHeight: props.defaultHeight,
      requestType: props.requestType,
      copyToSummary: props.copyToSummary,
    };
  }

  componentDidMount() {
    window.AP.request('/rest/api/3/myself')
      .then((data) => {
        let json = JSON.parse(data.body);
        this.setState({ userData: json.displayName });
      })
      .catch((e) => console.log(e.err));

    const copyToSummary = this.state.fieldConfig.copyToSummary;
    const copyRequestType = this.state.fieldConfig.copyRequestType;
    const requestType = this.state.requestType;
    const copyRequestTypeField = this.state.fieldConfig.copyRequestTypeField;

    if (this.state.copyToSummary) {
      window.AP.context.getContext(function (response) {
        if (!response.jira.issue) {
          var requestProperties = new window.AP.jiraServiceDesk.RequestProperties();

          window.AP.events.on('jira-servicedesk-request-properties-serialize', function () {
            let val = $(`#freeTextData`).val();

            let data = {
              field: 'summary',
              value: val,
              copy: copyToSummary,
              requestType: requestType?.name,
            };
            if (copyRequestType && copyRequestTypeField)
              data['copyRequestTypeField'] = copyRequestTypeField;

            requestProperties.serialize({
              com_company_twinitapp_location_issue_property: data,
            });
          });

          window.AP.events.on('jira-servicedesk-request-created');
          window.AP.events.on('jira-servicedesk-request-properties-validate', function () {
            var valid = true;

            if (!$(`#location`).val()) {
            }

            requestProperties.validate(valid);
          });
        }
      });
    }
  }

  handleChange = (val) => {
    if (val && val.length > 2) {
      this.setState({ selectedData: val });
      if (this.state.fieldConfig.usersType === 'Customer Users') {
        this.searchRequests(val, this);
      } else {
        this.searchIssues(val, this);
      }
    } else {
      this.setState({ selectedData: '', issuesData: null });
    }
    const comp = this;
    window.AP.context.getContext(function (response) {
      if (!response.jira.issue) return;
      comp.setValue(response.jira.issue.key, val);
    });
  };

  searchIssues(val, comp) {
    if (!this.state.fields || this.state.fields.length === 0) return;

    const fieldsVals = this.state.fields.map((n) => n);
    fieldsVals.push(this.state.fieldConfig.targetField);

    let jqlData = '';
    this.state.fieldConfig.targetIssueFields.forEach((element) => {
      let fieldKey = element;

      if (fieldKey.includes('customfield_')) {
        const key = fieldKey.replace('customfield_', '');
        fieldKey = `cf[${key}]`;
      }

      if (jqlData) jqlData = `${jqlData} OR `;

      jqlData = `${jqlData}${fieldKey} ~ '${val.trim()}*'`;
    });

    if (jqlData) jqlData = `(${jqlData})`;

    const jql = this.state.jql ? ` AND (${this.state.jql})` : '';

    var bodyData = {
      expand: 'names',
      jql: `${jqlData} ${jql} ORDER BY created DESC`,
      maxResults: 16,
      fieldsByKeys: false,
      fields: fieldsVals,
    };

    const strBodyData = JSON.stringify(bodyData);

    window.AP.request({
      type: 'POST',
      url: `/rest/api/3/search/jql`,
      contentType: 'application/json',
      data: strBodyData,
      success: function (response) {
        const data = JSON.parse(response);
        const issues = data.issues;

        comp.setState({ issuesData: issues });
      },
      error: function (xhr, statusText, errorThrown) {},
    });
  }

  searchRequests(val, comp) {
    if (!this.state.fields || this.state.fields.length === 0) return;

    const fieldsVals = this.state.fields.map((n) => n);
    fieldsVals.push(this.state.fieldConfig.targetField);

    let url = `/rest/servicedeskapi/request?searchTerm="${val}"`;

    if (this.state.fieldConfig.issuesStatus) {
      url = `${url}&requestStatus=${this.state.fieldConfig.issuesStatus}`;
    }

    window.AP.request(url)
      .then((data) => {
        let json = JSON.parse(data.body);
        const result = json.values;

        comp.setState({ issuesData: result });
      })
      .catch((e) => console.log(e.err));
  }

  handleDefaultParams = (data) => {
    this.setState({ defaultParams: data });
  };

  setValue(issueIdOrKey, value) {
    var jsonValue = '';
    if (value) {
      jsonValue = interpolate(this.state.fieldConfig.valueExpression, {
        item: value,
      });
    }

    const data = { fields: {} };
    data.fields[this.state.fieldConfig.targetField] = jsonValue;

    if (
      this.state.fieldConfig.additionalTargetField &&
      this.state.fieldConfig.additionalTargetFieldValue &&
      this.state.fieldConfig.additionalValueExpression
    ) {
      const additionalJsonValue = value
        ? interpolate(this.state.fieldConfig.additionalValueExpression, { item: value })
        : '';
      data.fields[this.state.fieldConfig.additionalTargetFieldValue] = additionalJsonValue;
    }

    const jsonData = JSON.stringify(data);
    window.AP.request({
      url: `/rest/api/3/issue/${issueIdOrKey}`,
      type: 'PUT',
      contentType: 'application/json',
      data: jsonData,
      success: function (responseText) {
        window.AP.jira.refreshIssuePage();
      },
      error: function (xhr, statusText, errorThrown) {},
    });
  }

  render() {
    if (!this.state.fieldConfig) return <div>Loading</div>;

    return (
      <div id={this.state.fieldConfig.id}>
        <input
          type='hidden'
          id='freeTextData'
          name='freeTextData'
          value={this.state.selectedData}
        ></input>
        <div>
          <span style={{ color: '#6b778c', fontSize: 12, fontWeight: 600 }}>
            {this.state.fieldConfig.name}
          </span>
        </div>
        <div>
          <Textfield
            name={'srchText_' + this.state.fieldConfig.id}
            id={'srchText_' + this.state.fieldConfig.id}
            onChange={(event) => this.handleChange(event.target.value)}
            aria-label='Search ...'
          />
        </div>
        <div>
          <span style={{ color: '#6b778c', fontSize: 12 }}>
            {this.state.fieldConfig.description}
          </span>
        </div>
        <div>
          {this.state.fields && this.state.fields.length > 0 ? (
            <PersonCasesResult
              id={'casesResult_' + this.state.fieldConfig.id}
              data={this.state.issuesData}
              fields={this.state.fields}
              usersType={this.state.fieldConfig.usersType}
              issueFieldsArray={this.state.issueFieldsArray}
              // defaultHeight={this.state.defaultHeight}
            ></PersonCasesResult>
          ) : null}
        </div>
      </div>
    );
  }
}

export default FreeTextField;
